import React from 'react';
import { Box, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

interface Props {
  testId?: string;
  checked?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}

const StyledButton = styled(RawButton)`
  &:disabled {
    opacity: 1;
  }
`;

interface StyledBoxProps {
  disabled?: boolean;
}
const StyledBox = styled(Box)<StyledBoxProps>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.border1 : theme.colors.accentContainer};
    border-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.border1 : theme.colors.accentContainer};
  }
`;

const ForfeitureSidePickerItem: React.FC<Props> = ({
  testId = 'toggle-button',
  checked,
  onClick,
  disabled,
  children,
}) => {
  return (
    <StyledButton
      data-testid={checked ? `${testId}_checked` : `${testId}`}
      onClick={onClick}
      disabled={disabled}
    >
      <StyledBox
        round="button1Round"
        disabled={disabled}
        pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}
        background={disabled ? 'border1' : checked ? 'accentContainer' : undefined}
        border={{ size: 'small', color: disabled ? 'border1' : checked ? 'transparent' : 'border1' }}
      >
        <Text
          style={{ lineHeight: 1 }}
          color={disabled ? 'textDisabled' : checked ? 'textAccent' : 'textBody'}
          size="medium"
          weight={400}
        >
          {children}
        </Text>
      </StyledBox>
    </StyledButton>
  );
};

export default ForfeitureSidePickerItem;
